import { FunctionComponent } from 'react';
import { Box, Button, SxProps } from '@mui/material';

interface PicContentProps {
    name: string;
    src: string;
    buttonText?: string;
    buttonHref?: string;
    buttonText2?: string;
    buttonHref2?: string;
    buttonText3?: string;
    buttonHref3?: string;
    buttonText4?: string;
    buttonHref4?: string;
    buttonText5?: string;
    buttonHref5?: string;
    buttonSx?: SxProps;
    gap?: string;
}

const PicContent: FunctionComponent<PicContentProps> = ({
    name,
    src,
    buttonText,
    buttonHref,
    buttonText2,
    buttonHref2,
    buttonText3,
    buttonHref3,
    buttonText4,
    buttonHref4,
    buttonText5,
    buttonHref5,
    buttonSx,
    gap,
}) => {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: gap ?? '3rem',
            }}
            data-test-id={`${name}-pic-area`}
        >
            {src && (
                <img
                    alt=""
                    src={src}
                    style={{
                        width: '32.5rem',
                        height: '18.625rem',
                        borderRadius: '8px',
                        objectFit: 'cover',
                    }}
                />
            )}

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '1rem',
                    width: '100%',
                }}
            >
                {buttonText && (
                    <Button
                        variant="contained"
                        sx={{ ...buttonSx, minWidth: '200px' }}
                        href={buttonHref ?? ''}
                        target="_blank"
                    >
                        {buttonText}
                    </Button>
                )}
                {buttonText2 && (
                    <Button
                        variant="contained"
                        sx={{ ...buttonSx, minWidth: '200px' }}
                        href={buttonHref2 ?? ''}
                        target="_blank"
                    >
                        {buttonText2}
                    </Button>
                )}
                {buttonText3 && (
                    <Button
                        variant="contained"
                        sx={{ ...buttonSx, minWidth: '87%' }}
                        href={buttonHref3 ?? ''}
                        target="_blank"
                    >
                        {buttonText3}
                    </Button>
                )}
                {buttonText4 && (
                    <Button
                        variant="contained"
                        sx={{ ...buttonSx, minWidth: '87%' }}
                        href={buttonHref4 ?? ''}
                        target="_blank"
                    >
                        {buttonText4}
                    </Button>
                )}
                {buttonText5 && (
                    <Button
                        variant="contained"
                        sx={{ ...buttonSx, minWidth: '87%' }}
                        href={buttonHref5 ?? ''}
                        target="_blank"
                    >
                        {buttonText5}
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default PicContent;
